module.exports = __webpack_public_path__ + "img/evaluate-yes.bfe06b01.png";